import type { IconSvgObject } from './types';

const TriangleRightIcon: IconSvgObject = [
  ["path", { d: "M17.9923 20H9.97692C5.00637 20 2.52109 20 2.06437 18.6269C1.60764 17.2538 3.59586 15.7594 7.5723 12.7707L15.5877 6.74622C18.3856 4.64326 19.7846 3.59178 20.8923 4.14682C22 4.70186 22 6.45432 22 9.95926V15.9837C22 17.877 22 18.8237 21.4131 19.4118C20.8262 20 19.8816 20 17.9923 20Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default TriangleRightIcon;
